document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.accordion-item');

    faqItems.forEach((item, index) => {
        const question = item.querySelector('.accordion-label');
        const answer = item.querySelector('.accordion-content');

        if (question && answer) {
            // Initialiser fermé
            answer.style.maxHeight = '0px';
            answer.style.opacity = '0';

            question.addEventListener('click', function () {
                const isOpen = answer.style.maxHeight !== '0px' && answer.style.maxHeight !== '';

                if (isOpen) {
                    // Fermer
                    console.log('Fermeture');
                    answer.style.maxHeight = '0px';
                    answer.style.opacity = '0';
                } else {
                    // Ouvrir
                    console.log('Ouverture, scrollHeight:', answer.scrollHeight);
                    answer.style.maxHeight = answer.scrollHeight + 'px';
                    answer.style.opacity = '1';
                }
            });
        }
    });
});
